import { SectionField } from 'app/common/metadata-models/sectionField';

// Mock data used for development and testing.
export class MockSectionDynamicChildFields {
    public sample_1: SectionField[] = [
    ];
}
